var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimalsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 10.752c1 0 3.194-.113 4 1.5 1 2-.321 3.071 2 4 2.5 1 3.652 2.044 3 4-.5 1.5-2 2-4.5 1.5-2.451-.49-2.5-1-5.5-1.5s-4.5 1-6 1-2.5-1-3-2.5.5-3 3-3.5 3-1.5 4-3c.8-1.2 2.333-1.5 3-1.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.568 10.903c.453-1.879 1.908-3.141 3.25-2.818 1.343.323 2.064 2.108 1.612 3.987-.453 1.88-1.907 3.142-3.25 2.819-1.342-.323-2.064-2.108-1.612-3.988zM4.5 7C5.88 7 7 8.567 7 10.5S5.88 14 4.5 14 2 12.433 2 10.5 3.12 7 4.5 7zM9.5 2C10.88 2 12 3.567 12 5.5S10.88 9 9.5 9 7 7.433 7 5.5 8.12 2 9.5 2zM15.5 2C16.88 2 18 3.567 18 5.5S16.88 9 15.5 9 13 7.433 13 5.5 14.12 2 15.5 2z",
    fill: "currentColor"
  })));
}
SvgAnimalsFilled.displayName = 'AnimalsFilled';
export default SvgAnimalsFilled;